module.exports = __webpack_public_path__ + "img/changePassword.88156cf5.svg";